import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../../atoms/SeoMainHeadline";
import type {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {getRoomsFlatsLabelWhere} from "../../constants/prices_address_rooms";
import {isAllRooms, RoomsFilter} from "../../constants/rcn_rooms_filter";
import {getHeaderPictures} from "../../helpers/get_header_pictures";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {getPricesAddressHeadline} from "../../utils/get_prices_address_headline";

interface Props {
    address: IPricesAddress;
    cityRegion: IRegionReportPrice;
    rooms: RoomsFilter;
}

export const PricesAddressHero = (props: Props) => {
    const {address, cityRegion, rooms} = props;

    const pictures = getHeaderPictures(cityRegion.slug);
    const {point, isLoading} = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");

    const stats = point && point.value > 0 ? point : null;
    // On the all-flats view there is no other size to fall back to, so the advice would be a dead end.
    const missingStatsText = `Za mało transakcji w rejestrze, żeby pokazać cenę ${getRoomsFlatsLabelWhere(rooms)}.${isAllRooms(rooms) ? "" : " Wybierz inny rozmiar mieszkania poniżej."}`;

    return (
        <Container className={containerStyle}>
            <div className={heroStyle}>
                <Picture
                    className={pictureStyle}
                    imageClassName={imageStyle}
                    fit="cover"
                    alt={`${cityRegion.short_name} — panorama miasta`}
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919}
                    ]}
                />

                <div className={overlayStyle} />

                <div className={contentStyle}>
                    <SeoMainHeadline as="h1" variant="headline_0" fontFamily="secondary" color="var(--colors-white)" className={headlineStyle}>
                        {getPricesAddressHeadline(address.rcnAddress, address.city.short_name)}
                    </SeoMainHeadline>

                    {stats && (
                        <Text variant="headline_0" as="p" color="var(--colors-white)">
                            {priceFormat(Math.round(stats.value), {precision: 0})}/za m²
                        </Text>
                    )}

                    {!stats && !isLoading && (
                        <Text variant="body_copy_1" color="var(--colors-white)">
                            {missingStatsText}
                        </Text>
                    )}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    my: 3,

    md: {
        my: 3.5
    }
});

const heroStyle = css({
    position: "relative",
    display: "flex",
    overflow: "hidden",
    minHeight: "348px",
    borderRadius: 3,

    md: {
        minHeight: "400px"
    }
});

const pictureStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});

const imageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const overlayStyle = css({
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(23, 23, 28, 0.94902) 0%, rgba(23, 23, 28, 0.819608) 60%, rgba(23, 23, 28, 0.501961) 100%)",

    md: {
        background: "linear-gradient(90deg, rgba(23, 23, 28, 0.96) 0%, rgba(23, 23, 28, 0.88) 45%, rgba(23, 23, 28, 0.45) 100%)"
    }
});

const contentStyle = css({
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto",
    py: 2,
    px: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 1.5,

    md: {
        p: 7,
        // 844px of text plus the padding.
        maxWidth: "956px"
    }
});

// headline_0 is semibold; the serif heading of this hero reads regular.
const headlineStyle = css({
    fontWeight: "400"
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../../atoms/SeoMainHeadline";
import type {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {getRoomsFlatsLabelWhere} from "../../constants/prices_address_rooms";
import {isAllRooms, RoomsFilter} from "../../constants/rcn_rooms_filter";
import {getHeaderPictures} from "../../helpers/get_header_pictures";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {getPricesAddressHeadline} from "../../utils/get_prices_address_headline";

interface Props {
    address: IPricesAddress;
    cityRegion: IRegionReportPrice;
    rooms: RoomsFilter;
}

export const PricesAddressHero = (props: Props) => {
    const {address, cityRegion, rooms} = props;

    const pictures = getHeaderPictures(cityRegion.slug);
    const {point, isLoading} = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");

    const stats = point && point.value > 0 ? point : null;
    // On the all-flats view there is no other size to fall back to, so the advice would be a dead end.
    const missingStatsText = `Za mało transakcji w rejestrze, żeby pokazać cenę ${getRoomsFlatsLabelWhere(rooms)}.${isAllRooms(rooms) ? "" : " Wybierz inny rozmiar mieszkania poniżej."}`;

    return (
        <Container className={containerStyle}>
            <div className={heroStyle}>
                <Picture
                    className={pictureStyle}
                    imageClassName={imageStyle}
                    fit="cover"
                    alt={`${cityRegion.short_name} — panorama miasta`}
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919}
                    ]}
                />

                <div className={overlayStyle} />

                <div className={contentStyle}>
                    <SeoMainHeadline as="h1" variant="headline_0" fontFamily="secondary" color="var(--colors-white)" className={headlineStyle}>
                        {getPricesAddressHeadline(address.rcnAddress, address.city.short_name)}
                    </SeoMainHeadline>

                    {stats && (
                        <Text variant="headline_0" as="p" color="var(--colors-white)">
                            {priceFormat(Math.round(stats.value), {precision: 0})}/za m²
                        </Text>
                    )}

                    {!stats && !isLoading && (
                        <Text variant="body_copy_1" color="var(--colors-white)">
                            {missingStatsText}
                        </Text>
                    )}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    my: 3,

    md: {
        my: 3.5
    }
});

const heroStyle = css({
    position: "relative",
    display: "flex",
    overflow: "hidden",
    minHeight: "348px",
    borderRadius: 3,

    md: {
        minHeight: "400px"
    }
});

const pictureStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});

const imageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const overlayStyle = css({
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(23, 23, 28, 0.94902) 0%, rgba(23, 23, 28, 0.819608) 60%, rgba(23, 23, 28, 0.501961) 100%)",

    md: {
        background: "linear-gradient(90deg, rgba(23, 23, 28, 0.96) 0%, rgba(23, 23, 28, 0.88) 45%, rgba(23, 23, 28, 0.45) 100%)"
    }
});

const contentStyle = css({
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto",
    py: 2,
    px: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 1.5,

    md: {
        p: 7,
        // 844px of text plus the padding.
        maxWidth: "956px"
    }
});

// headline_0 is semibold; the serif heading of this hero reads regular.
const headlineStyle = css({
    fontWeight: "400"
});
